











import Vue from 'vue';
import Component from 'vue-class-component';
import { protectWords } from '@/common/ts/brand-safe-hypens/BrandSafeHyphens';
import IntersectionDirective from '../../common/vue/intersection-directive';

const ParagraphHeadlineProps = Vue.extend({
  props: {
    headlineTag: {
      type: String,
      default: 'h2',
    },
    headlineIcon: {
      type: String,
      required: false,
    },
  },
});

@Component({
  directives: {
    intersect: IntersectionDirective,
  },
})
export default class ParagraphHeadline extends ParagraphHeadlineProps {
  $refs!: {
    headline: HTMLElement;
  }

  mounted () {
    protectWords(this.$refs.headline);
  }

  get tagClass () {
    const classes = ['brandhub-paragraph-indent', 'brandhub-paragraph-headline__title'];

    if (this.headlineIcon) {
      classes.push('brandhub-paragraph-headline__title--has-icon');
    }

    return classes.join(' ');
  }
}
